export function linkToCardReissue() {
  return "/card/reissue";
}
